<script setup>
import ButtonComponent from "@/components/modals/UI/ButtonComponent.vue";
</script>

<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-content__header">
        <slot name="header"></slot>
      </div>

      <slot></slot>

      <div class="modal-content__footer">
        <ButtonComponent @click="$emit('allowed')" variant="primary">Згода</ButtonComponent>
        <ButtonComponent @click="$emit('disallowed')" variant="secondary">Відхилити</ButtonComponent>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal {
  width: 480px;

  position: fixed;
  bottom: 20px;
  right: 20px;

  background-color: #fff;
  border-radius: 5px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);

  z-index: 100;

  transition: all 0.3s ease-out;
}

.modal:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.46)
}

.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  font-family: 'Montserrat', sans-serif;

  gap: 10px;

  padding: 20px;
}

.modal-content__header {
  font-size: 22px;
  font-weight: 600;
}

.modal-content__footer {
  display: flex;

  gap: 10px;
}

@media screen and (max-width: 500px) {
  .modal {
    width: 100%;
    bottom: 0;
    right: 0;
    border-radius: 0;
  }
}
</style>
